import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { CopiableContactField } from '@/components/research-bar/copiable-contact-field'

interface CloudyContactCardProps {
  children: ReactNode
  title: string
}

interface CloudyCopiableContactCardProps {
  icon: LucideIcon
  label: string
  title: string
  value: string
}

export function CloudyContactCard({ children, title }: CloudyContactCardProps) {
  return (
    <div className="bg-brand-500 relative overflow-hidden rounded-2xl p-6">
      <img
        alt="cloud"
        className="pointer-events-none absolute top-0 right-0"
        src="/icons/cloud.svg"
      />
      <div className="relative flex flex-col gap-3">
        <h3 className="bg-brand-500/50 w-fit rounded-lg p-1 text-xl font-semibold text-white">
          {title}
        </h3>
        {children}
      </div>
    </div>
  )
}

export function CloudyCopiableContactCard({
  icon,
  label,
  title,
  value,
}: CloudyCopiableContactCardProps) {
  return (
    <CloudyContactCard title={title}>
      <CopiableContactField
        fieldClassName="border-none bg-white"
        icon={icon}
        iconClassName="text-gray-light-500"
        label={label}
        labelClassName="text-sm font-medium text-white"
        value={value}
      />
    </CloudyContactCard>
  )
}
